import Checkbox from '@components/Checkbox';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import FilterContext from './context/FilterContext';

function FilterItems<F>() {
    const { filterItems, filters, setFilters } = useContext(FilterContext);
    const { t } = useTranslation('common');
    const toggleFilter = (filter: F) => {
        if (filters?.includes(filter)) {
            setFilters?.(filters.filter((v) => v !== filter));
        } else {
            setFilters?.([...(filters || []), filter]);
        }
    };

    if (filterItems) {
        return (
            <Fragment>
                <Row spacing={4}>
                    <Text size='lg' fontWeight='bold'>{t('filter.filter')}</Text>
                    {filterItems.length > 1 && (
                        <Text color={colors.gray6} fontWeight='medium'>
                            {t('filter.multipleSelect')}
                        </Text>
                    )}
                </Row>
                {filterItems?.map((option) => (
                    <Checkbox isChecked={filters?.includes(option.value)}
                        // @ts-ignore
                        key={option.value}
                        onClick={() => toggleFilter(option.value)}>
                        {option.label}
                    </Checkbox>
                ))}
            </Fragment>
        );
    }
    return (<Fragment/>);
}

export default FilterItems;
